var exports = {
  "kL": "x31de4314--2a531b--container",
  "$h": "x31de4314--2a531b--closed",
  "Qs": "x31de4314--2a531b--content",
  "VG": "x31de4314--2a531b--title-block",
  "DD": "x31de4314--2a531b--title",
  "c5": "x31de4314--2a531b--arrow-wrapper",
};

module.exports = exports;
